import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../Auth/AuthContext';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { serverUrl } from '../../Constant/Static/config';
import PopModal from '../../Constant/Custom/Models/PopModal';
import Loader from '../../Constant/Custom/Loader';

function TentativePage() {
  const { auth } = useContext(AuthContext);
  const [TentativeStatus, setTentativeStatus] = useState(null);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [csrfToken, setCsrfToken] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState({ icon: '', title: '', text: '' });
  const [showCancelButton, setShowCancelButton] = useState(false);
  const [onConfirm, setOnConfirm] = useState(() => () => { });
  const [onCancel, setOnCancel] = useState(() => () => { });
  const navigate = useNavigate();

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => {
    setIsModalOpen(false);
    setShowCancelButton(false);
    setOnConfirm(() => () => { });
    setOnCancel(() => () => { });
  };

  const storedUser = auth.user;

  useEffect(() => {
    if (user) {
      // console.log('User state updated:', user);
    }
  }, [user]);

  const updateAllotStatus = async (choice) => {
    setLoading(true);
    try {
      setIsModalOpen(false);
      const response = await axios.post(
        `${serverUrl}/api/choicefilling/user/tentativeallotment`,
        {
          appno: storedUser.appno,
          tentativeChoice: choice,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'CSRF-Token': csrfToken,
          },
          withCredentials: true,
        }
      );
      if (response.status === 200) {
        // console.log('API response:', response.data);
        setLoading(false);
        setModalType({
          icon: 'success',
          title: 'Choice Added',
          text: `Your choice was added successfully.`,
        });
        setShowCancelButton(false);
        setOnConfirm(() => () => {
          setIsModalOpen(false);
          fetchTAStatus();
        });
        setOnCancel(() => () => { });
        setIsModalOpen(true);
      }
    } catch (err) {
      console.error('Error adding choice:', err);
      closeModal();
      setModalType({
        icon: 'error',
        title: 'Addition Failed',
        text: 'Something went wrong while adding your choice.',
      });
      setShowCancelButton(false);
      setOnConfirm(() => closeModal);
      setOnCancel(() => () => { });
      openModal();
    }
  };

  useEffect(() => {
    const fetchCsrfToken = async () => {
      try {
        const response = await axios.get(`${serverUrl}/api/csrf-token`, {
          withCredentials: true,
        });
        setCsrfToken(response.data.csrfToken);
      } catch (error) {
        console.error('Error fetching CSRF token:', error);
      }
    };

    fetchCsrfToken();
  }, []);

  useEffect(() => {
    const checkSession = async () => {
      try {
        if (!storedUser) {
          throw new Error('No active session found');
        }

        if (!storedUser.appno || !storedUser.mobile || !storedUser.email) {
          throw new Error('Incomplete session data');
        }

        const dataToSend = {
          appno: storedUser.appno,
          mobile: storedUser.mobile,
          email: storedUser.email,
        };

        const response = await axios.post(
          `${serverUrl}/api/user/tentative`,
          dataToSend,
          {
            withCredentials: true,
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-Token': csrfToken,
            },
          }
        );

        if (response.status === 200 && response.data) {
          setUser(response.data);
          // console.log('API response:', response.data);
        } else {
          throw new Error('Failed to load user data from the server');
        }
      } catch (error) {
        console.error('Error fetching session:', error);
        setError(error.message);
        // navigate('/login');
      } finally {
        setLoading(false);
      }
    };

    if (csrfToken) {
      checkSession();
    }
  }, [csrfToken, storedUser, navigate]);

  const fetchTAStatus = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${serverUrl}/api/choicefilling/user/choices/tentativestatus`,
        {
          appno: storedUser.appno,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'CSRF-Token': csrfToken,
          },
          withCredentials: true,
        }
      );
      if (response.status === 200) {
        // console.log(response.data.statusTA);
        setTentativeStatus(response.data.statusTA);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (csrfToken && storedUser) {
      fetchTAStatus();
    }
  }, [csrfToken, storedUser]);

  const handleChoice = (choice) => {
    let message = '';
    if (choice === 'A') {
      message =
        'I ACCEPT THE ALLOTTED CHOICE(தாங்கள் ஒதுக்கீடு செய்த கல்லூரியை ஏற்றுக்கொள்கின்றேன்)';
    }
    if (choice === 'AU') {
      message =
        'I ACCEPT THE ALLOTTED CHOICE, IF ANY UPWARD MOVEMENT POSSIBLE KINDLY CONSIDER(தாங்கள் ஒதுக்கீடு செய்த கல்லூரியை ஏற்றுக்கொள்கின்றேன், இருப்பினும் ஏதாவது இதற்கு மேலுள்ள கல்லூரிகள் கிடைக்கப்பெறின், பரிசீலனை செய்யுமாறு கேட்டுக்கொள்கின்றேன்)';
    }
    if (choice === 'U') {
      message =
        'IF ANY UPWARD MOVEMENT POSSIBLE KINDLY CONSIDER(தாங்கள் ஒதுக்கீடு செய்த கல்லூரியை ஏற்றுக்கொள்கின்றேன், இருப்பினும் ஏதாவது இதற்கு மேலுள்ள கல்லூரிகள் கிடைக்கப்பெறின், பரிசீலனை செய்யுமாறு கேட்டுக்கொள்கின்றேன்)';
    }
    if (choice === 'NP') {
      message =
        'I MOVE TO THE NEXT ROUND(நான் அடுத்த ஒதுக்கீட்டில் கலந்துக்கொள்ள விரும்புகிறேன்)';
    }
    if (choice === 'Q') {
      message =
        'I QUIT FROM COUNSELLING(நான் கலந்தாய்விலிருந்து வெளியேறுகிறேன்)';
    }
    setModalType({
      icon: 'info',
      title: 'Confirm Choice',
      text: `${message}`,
    });
    setShowCancelButton(true);
    setOnConfirm(() => () => updateAllotStatus(choice));
    setOnCancel(() => () => setIsModalOpen(false));
    setIsModalOpen(true);
  };

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div className='homePage' style={{ padding: '20px' }}>
      <div className='welcomeApplicant'>
        {user ? (
          <>

            {TentativeStatus != 'X' && TentativeStatus != 'H' && TentativeStatus != 'E' && <h3 style={{ textAlign: 'center', fontSize: '40px', borderBottom: '2px solid gray', paddingBottom: '10px' }}>Tentative Allotment</h3>}
            <h1>{user.userName}</h1>
            <div>
              <p><b>Application No: </b>{user.appno}</p>
              <p><b>Email ID: </b>{user.email}</p>
              {/* <p><b>Date of Reg: </b>{user.dateOfReg}</p> */}
            </div>
          </>
        ) : (
          <div>No user data available</div>
        )}
      </div>

      <div className='tableContainer'>
        {user && ['A', 'AU', 'TA'].includes(TentativeStatus) && TentativeStatus != "W" && (
          <table className='choose-table'>
            <thead>
              <tr>
                <th>ALLOTTED COLLEGE CODE</th>
                <th>ALLOTTED COLLEGE NAME</th>
                <th>ALLOTTED BRANCH</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{user?.allotCollCode ? user?.allotCollCode : '-'}</td>
                <td>{user?.allotInst ? user?.allotInst : '-'}</td>
                <td>{user?.allotBranch ? user?.allotBranch : '-'}</td>
              </tr>
            </tbody>
          </table>
        )}
        {TentativeStatus == "H" && (
          <table className='choose-table'>
            <div ><h4 style={{ textAlign: "center", color: "red", fontSize: "20px" }}>Seats not available as per your choices.</h4></div>
          </table>
        )}
        {TentativeStatus == "E" && (
          <table className='choose-table'>
            <div ><h4 style={{ textAlign: "center", color: "red", fontSize: "20px" }}>No choices filled. Hence no seat is allotted.</h4></div>
          </table>
        )}
        {TentativeStatus == "X" && (
          <table className='choose-table'>
            <div ><h4 style={{ textAlign: "center", color: "red", fontSize: "20px" }}>As per your Choice,You Quit from Counselling.</h4></div>
          </table>
        )}
        {/* {TentativeStatus == "H" && (
          <table className='choose-table'>
            <div ><h4 style={{ textAlign: "center", color: "red", fontSize: "20px" }}>As per your Choice ,wait for the Next round of Counselling </h4></div>
          </table>
        )} */}

        {TentativeStatus != "TA" && TentativeStatus != "W" && TentativeStatus != "X" && TentativeStatus != "H" && TentativeStatus != "E" && (
          <table className='choose-table'>
            <thead>
              <tr>
                <th>Selected Choice</th>
              </tr>
            </thead>
            <tbody>
              {TentativeStatus === 'A' && (
                <tr>
                  <td>
                    <b>
                      I ACCEPT THE ALLOTTED CHOICE<br />
                      <span className='text-danger'>
                        (தாங்கள் ஒதுக்கீடு செய்த கல்லூரியை ஏற்றுக்கொள்கின்றேன்)
                      </span>
                    </b>
                  </td>
                </tr>
              )}
              {TentativeStatus === 'AU' && (
                <tr>
                  <td>
                    <b>
                      I ACCEPT THE ALLOTTED CHOICE, IF ANY UPWARD MOVEMENT POSSIBLE KINDLY CONSIDER<br />
                      <span className='text-danger'>
                        (தாங்கள் ஒதுக்கீடு செய்த கல்லூரியை ஏற்றுக்கொள்கின்றேன், இருப்பினும் ஏதாவது இதற்கு மேலுள்ள கல்லூரிகள் கிடைக்கப்பெறின், பரிசீலனை செய்யுமாறு கேட்டுக்கொள்கின்றேன்)
                      </span>
                    </b>
                  </td>
                </tr>
              )}
              {TentativeStatus === 'U' && (
                <tr>
                  <td>
                    <b>
                      IF ANY UPWARD MOVEMENT POSSIBLE KINDLY CONSIDER<br />
                      <span className='text-danger'>
                        (ஏதாவது இதற்கு மேலுள்ள கல்லூரிகள் கிடைக்கப்பெறின், பரிசீலனை செய்யுமாறு கேட்டுக்கொள்கின்றேன்)
                      </span>
                    </b>
                  </td>
                </tr>
              )}
              {TentativeStatus === 'NP' && (
                <tr>
                  <td>
                    <b>
                      I MOVE TO THE NEXT ROUND<br />
                      <span className='text-danger'>
                        (நான் அடுத்த ஒதுக்கீட்டில் கலந்துக்கொள்ள விரும்புகிறேன்)
                      </span>
                    </b>
                  </td>
                </tr>
              )}
              {TentativeStatus === 'Q' && (
                <tr>
                  <td>
                    <b>
                      I QUIT FROM COUNSELLING<br />
                      <span className='text-danger'>
                        (நான் கலந்தாய்விலிருந்து வெளியேறுகிறேன்)
                      </span>
                    </b>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}

        {TentativeStatus === "TA" && (
          <table className='choose-table'>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Choose Based on Allotment Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>
                  <b>
                    I ACCEPT THE ALLOTTED CHOICE<br />
                    <span className='text-danger'>
                      (தாங்கள் ஒதுக்கீடு செய்த கல்லூரியை ஏற்றுக்கொள்கின்றேன்)
                    </span>
                  </b>
                </td>
                <td>
                  <button
                    className='button button-primary'
                    onClick={() => handleChoice('A')}
                  >
                    CHOOSE
                  </button>
                </td>
              </tr>
              <tr>
                <td>2</td>
                <td>
                  <b>
                    I ACCEPT THE ALLOTTED CHOICE, IF ANY UPWARD MOVEMENT POSSIBLE KINDLY CONSIDER<br />
                    <span className='text-danger'>
                      (தாங்கள் ஒதுக்கீடு செய்த கல்லூரியை ஏற்றுக்கொள்கின்றேன், இருப்பினும் மேலுள்ள கல்லூரிகள் கிடைக்கப்பெறின், பரிசீலனை செய்யுமாறு கேட்டுக்கொள்கின்றேன்)
                    </span>
                  </b>
                </td>
                <td>

                  <button
                    className='button button-primary'
                    onClick={() => handleChoice('AU')}
                    disabled={user?.allotCollCode == user?.firstCollCode && user?.allotBranch == user?.firstBranch}
                  >
                    CHOOSE
                  </button>
                </td>
              </tr>
              <tr>
                <td>3</td>
                <td>
                  <b>
                    I MOVE TO THE NEXT ROUND<br />
                    <span className='text-danger'>
                      (நான் அடுத்த ஒதுக்கீட்டில் கலந்துக்கொள்ள விரும்புகிறேன்)
                    </span>
                  </b>
                </td>
                <td>
                  <button
                    className='button button-primary'
                    onClick={() => handleChoice('NP')}
                  >
                    CHOOSE
                  </button>
                </td>
              </tr>
              <tr>
                <td>4</td>
                <td>
                  <b>
                    I QUIT FROM COUNSELLING<br />
                    <span className='text-danger'>
                      (நான் கலந்தாய்விலிருந்து வெளியேறுகிறேன்)
                    </span>
                  </b>
                </td>
                <td>
                  <button
                    className='button button-primary'
                    onClick={() => handleChoice('Q')}
                  >
                    CHOOSE
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        )}
        {TentativeStatus === "W" && (<>
          <table className='choose-table'>
            <tbody>
              <tr>
                <td className="not-alloted">No college Alloted From your choices</td>
              </tr>
            </tbody>
          </table>
          <table className='choose-table'>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Choose Based on Allotment Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>

              <tr>
                <td>1</td>
                <td>
                  <b>
                    ACCEPTING IF ANY UPWARD MOVEMENT POSSIBLE<br />
                    <span className='text-danger'>
                      (எனது விருப்ப கல்லூரிகளில் ஏதாவது ஒன்று திரும்ப கிடைக்க வாய்ப்பு இருந்தால் மேல் நோக்கு நகர்வுக்கு [Upward Movement] சம்மதிக்கிறேன்.)
                    </span>
                  </b>
                </td>
                <td>
                  <button
                    className='button button-primary'
                    onClick={() => handleChoice('U')}
                  >
                    CHOOSE
                  </button>
                </td>
              </tr>
              <tr>
                <td>2</td>
                <td>
                  <b>
                    I MOVE TO THE NEXT ROUND<br />
                    <span className='text-danger'>
                      (நான் அடுத்த ஒதுக்கீட்டில் கலந்துக்கொள்ள விரும்புகிறேன்)
                    </span>
                  </b>
                </td>
                <td>
                  <button
                    className='button button-primary'
                    onClick={() => handleChoice('NP')}
                  >
                    CHOOSE
                  </button>
                </td>
              </tr>
              <tr>
                <td>3</td>
                <td>
                  <b>
                    I QUIT FROM COUNSELLING<br />
                    <span className='text-danger'>
                      (நான் கலந்தாய்விலிருந்து வெளியேறுகிறேன்)
                    </span>
                  </b>
                </td>
                <td>
                  <button
                    className='button button-primary'
                    onClick={() => handleChoice('Q')}
                  >
                    CHOOSE
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </>)}
      </div>
      {(TentativeStatus === 'A' || TentativeStatus === 'AU') && (
        <>
          <h1 id='tablink'>Kindly Wait For Provisional Allotment</h1>
          <h1 id='tablinktamil'>
            (தயவு செய்து இறுதி ஒதுக்கீட்டுக்காக காத்திருக்கவும்)
          </h1>
        </>
      )}
      <PopModal
        isOpen={isModalOpen}
        type={modalType}
        confirmButtonText={
          modalType.icon === 'success' || modalType.icon === 'error' ? 'OK' : 'Yes'
        }
        cancelButtonText='No'
        onConfirm={onConfirm}
        onCancel={showCancelButton ? onCancel : null}
        showCancelButton={showCancelButton}
      />
    </div>
  );
}

export default TentativePage;